import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "margin-top": "20px"
  }
};
import AdvertLaunchBaseInfo from './AdvertLaunchBaseInfo';
import AdvertLaunchDetail from './AdvertLaunchDetail';
import { onMounted, reactive, ref } from "vue";
export default {
  __name: 'AdvertLaunchInfo',
  props: {
    title: {
      type: String,
      default: '投放任务明细',
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    advertLaunch: {
      type: Object
    },
    roleId: {
      type: String,
      default: ''
    },
    roleFlag: {
      type: String,
      default: ''
    },
    currentAction: {
      type: String
    }
  },
  emits: ['update:visible', 'refresh'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const props = __props;
    const data = reactive({});
    const elLoading = ref(false);
    const close = () => {
      emits('update:visible', false);
    };
    const submit = () => {
      emits('update:visible', false);
      emits('refresh');
    };
    onMounted(() => {});
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.title,
        "model-value": __props.visible,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true,
        fullscreen: ""
      }, {
        footer: _withCtx(() => [...(_cache[0] || (_cache[0] = []))]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", null, [_createVNode(_unref(AdvertLaunchBaseInfo), {
          "advert-launch": __props.advertLaunch,
          "role-flag": __props.roleFlag
        }, null, 8, ["advert-launch", "role-flag"])]), _createElementVNode("div", _hoisted_1, [_createVNode(_unref(AdvertLaunchDetail), {
          "advert-launch": __props.advertLaunch,
          "role-id": __props.roleId,
          "role-flag": __props.roleFlag,
          "current-action": __props.currentAction,
          onSubmit: submit
        }, null, 8, ["advert-launch", "role-id", "role-flag", "current-action"])])])]),
        _: 1
      }, 8, ["title", "model-value"]);
    };
  }
};